import { Injectable, TemplateRef } from '@angular/core';

export interface Toast {
  text?: string;
  template?: TemplateRef<any>;
  classname: string;
  delay: number;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  toasts: Toast[] = [];

  show(text: string, classname: string, delay = 3000): Toast {
    const newToast = {
      text,
      classname,
      delay,
    };
    this.toasts = [...this.toasts, newToast];
    return newToast;
  }

  showTemplate(template: TemplateRef<any>, classname: string, delay = 3000): Toast {
    const newToast = {
      template,
      classname,
      delay,
    };
    this.toasts = [...this.toasts, newToast];
    return newToast;
  }

  showError(message: string) {
    this.show(message, 'text-white bg-danger', 5000);
  }

  showInfo(message: string) {
    this.show(message, 'text-white bg-info');
  }

  showSuccess(message: string) {
    this.show(message, 'text-white bg-primary');
  }

  remove(toast: Toast) {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }

  clear() {
    this.toasts = [];
  }
}
